export default __webpack_public_path__ + "static/media/635.74d8bba3.png";